import Contact from "../lens/Contact";
import Experience from "../lens/Experience";
import Home from "../lens/Home";
import Projects from "../lens/Projects";

export const lensMapping:{[key: string]: any} = {
    home:<Home/>,
    experience: <Experience/>,
    projects: <Projects/>,
    contact: <Contact/>,
}


export const getLens = (lens: string) => {
    return lensMapping[lens];
}